import { Suspense, lazy } from "react";

const GoogleReviewsCarousel = lazy(() =>
  import("@/components/google-reviews-carousel").then((m) => ({ default: m.GoogleReviewsCarousel })),
);

/** Bandeau d'avis Google — preuve sociale réutilisable sur toutes les pages publiques. */
export function ReviewsProof() {
  return (
    <Suspense fallback={<div className="min-h-[30vh]" />}>
      <GoogleReviewsCarousel />
    </Suspense>
  );
}
